import {onMounted, onUnmounted} from 'vue';

export function useObserveResize(chartInstance, target) {
    const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
            if (entry.target === target.value && chartInstance.value) {
                chartInstance.value.resize();
            }
        }
    });

    onMounted(() => {
        target.value && resizeObserver.observe(target.value);
    });

    onUnmounted(() => {
        target.value && resizeObserver.unobserve(target.value);
    });
}